var _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu-tab-offer-smartphone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hamburger-menu"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    transform: "translate(2.98 6.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18",
    transform: "translate(18.04) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_388",
    "data-name": "Rectangle 388",
    width: 17.995,
    height: 1.1,
    transform: "translate(1.1) rotate(90)",
    fill: "#1f1f28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(0.06 0.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M1.1,0V18H.1L0,17.433V0Z",
    fill: "#1f1f28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "minus-2-2",
    "data-name": "minus-2",
    transform: "translate(0 5.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18-2",
    "data-name": "Rectangle_18",
    transform: "translate(18.04) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394-2",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_388-2",
    "data-name": "Rectangle 388",
    width: 17.995,
    height: 1.1,
    transform: "translate(1.1) rotate(90)",
    fill: "#1f1f28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_395-2",
    "data-name": "Group 395",
    transform: "translate(0.06 0.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307-2",
    "data-name": "Path 307",
    d: "M1.1,0V18H.1L0,17.433V0Z",
    fill: "#1f1f28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "minus-2-3",
    "data-name": "minus-2",
    transform: "translate(0 10.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18-3",
    "data-name": "Rectangle_18",
    transform: "translate(18.04) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394-3",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_388-3",
    "data-name": "Rectangle 388",
    width: 17.995,
    height: 1.1,
    transform: "translate(1.1) rotate(90)",
    fill: "#1f1f28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_395-3",
    "data-name": "Group 395",
    transform: "translate(0.06 0.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307-3",
    "data-name": "Path 307",
    d: "M1.1,0V18H.1L0,17.433V0Z",
    fill: "#1f1f28"
  }))))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "MENU",
    transform: "translate(0 24)",
    fill: "#1f1f28",
    fontSize: 8,
    fontFamily: "Gebauer-Medium, Gebauer-Regular",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6
  }, "MENU"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.81b24203.svg";
export { ForwardRef as ReactComponent };